<template>
<div class="front-cover">
  <div class="title">
    <!--
    <div class="logo">
      <img src="https://placehold.jp/300x150.png?text=LOGO" alt="事業計画書ロゴ">
    </div>
  -->
    <div class="maintitle">
      <h1>{{ item.data.title }}</h1>
    </div>
    <div class="subtitle">
      {{ item.data.subTitle }}
    </div>
  </div>
  <div class="author">
    <div class="author-inner">
      <div class="create-date">{{ $planConfig.dateFormat(item.data.createDate, 'yyyy年m月d日') }}</div>
      <div class="company-name"
        v-if="item.data.companyFormat === 'corporation'">
        {{ item.data.companyName }}
      </div>
      <div class="user-name">{{ item.data.authorName }}</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
